import $ from "cash-dom"
import tinyload from '../util/tinyload.js'
import debounce from "../util/debounce.js"

export default class BlockBgModule {

    static name = 'blockbg'

    constructor(node) {

        const $node = $(node)
        const data = this.data = $node.data('bg')
        const mqs = this.mqs = data.map(m => window.matchMedia(m.media))
        const $blockBg = this.$blockBg = $('<img src="#" class="block__bg lazy lazy--hidden" />').appendTo(node)

        $(window).on('resize', debounce(this.handleResize, 100))

        $node.addClass('loader')

        //initial load
        for(let i=0; i<data.length; i++) {
            if(mqs[i].matches) {

                const url = data[i].url
                $blockBg.attr('src', url)
                
                tinyload(url, function() {
                    $node.removeClass('loader')
                    $blockBg
                        .removeClass('lazy--hidden')
                        .one('transitionend', () => {
                            $blockBg.removeClass('lazy')
                        })
                })

                break
            }
        }
    }
    
    handleResize = () => {

        const { data, mqs, $blockBg } = this

        for(let i=0; i<data.length; i++) {
            if(mqs[i].matches) {
                const url = data[i].url
                //console.log('handleResize matched', mqs[i])
                $blockBg.attr('src', url)
                break
            }
        }
    }
}